import { Component, OnInit } from '@angular/core'
//import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router'
import { TranslateService } from '@ngx-translate/core'
import { Subscription } from 'rxjs'
import { OrderReturn} from '../../models/orderReturn.model'
import { SharedService } from 'src/app/shared/services/shared.service'
import { OrderReturnService } from '../../services/order-return.service'
import { environment } from 'src/environments/environment'
import { OrderReturnDetailsStatus } from '../../models/orderReturn-details.enum'
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms'
import { ConfirmationMessageComponent } from 'src/app/shared/components/confirmation-message/confirmation-message'
import { ToastrService } from 'ngx-toastr'
import { MatDialog } from '@angular/material/dialog'

@Component({
	selector: 'app-order-return-details',
	templateUrl: './order-return-details.component.html',
	styleUrls: ['./order-return-details.component.scss'],
})
export class OrderReturnDetailsComponent implements OnInit {
	subscription = new Subscription()
	formData: FormGroup = new FormGroup({})
	
	returnData!: OrderReturn
	imagePath = environment.attachmentPath
	ReturnStatus = OrderReturnDetailsStatus
	breadCrumbRout: any
	matValue: any
    extraFees:number =0
	notes :string =""
	constructor(
		private activeRout: ActivatedRoute,
		public translate: TranslateService,
		private SharedService: SharedService,
		private orderReturnService: OrderReturnService,
		private toaster: ToastrService,
		private dialog: MatDialog,
		private router: Router,
		private fb: FormBuilder
	) {
		
		this.formData = this.fb.group({
			notes: [''] ,
			extraFees:['',[Validators.maxLength(4)] ]// Initialize the form control with an empty value
		  });
	  
		  // Optionally, subscribe to the value changes of the form control
		//   this.formData.get('notes')?.valueChanges.subscribe(value => {
		// 	this.notes = value;  // Update the component variable when form value changes
		//   });
		//   this.formData.get('extraFees')?.valueChanges.subscribe(value => {
		// 	this.extraFees = value;  // Update the component variable when form value changes
		//   });

		let rout = this.SharedService.breadCrumbRout.subscribe((res: any) => {
			this.breadCrumbRout = res
		})
		rout.unsubscribe()
		this.breadCrumbRout['order-Return-details'] = {
			name: '',
			id: '',
			url: '',
			queryParams: null,
		}
		this.SharedService.breadCrumbRout.next(this.breadCrumbRout)
	}

	ngOnInit(): void {
		debugger
		this.initForm()
		const id = this.activeRout.snapshot.params['id']
		this.getOrderReturn(id)
		this.subscription.add(
			this.formData.valueChanges.subscribe((res) => {
				this.matValue = this.getController('payStatus').value;
				this.notes =this.getController('notes').value;

			})
		)
	}
	ngOnChanges(): void {
		this.initForm()
	}
	initForm() {

		
		this.formData = new FormGroup({
			//payStatus: new FormControl('', [Validators.required]),
			extraFees: new FormControl(0, [
				
				Validators.min(0),
				Validators.max(this.returnData?.order.orderTotalAmount),
			]),
			notes: new FormControl(),
		})
		this.subscription.add(
			this.formData.valueChanges.subscribe((res) => {
				this.matValue = this.getController('payStatus').value;
				this.notes =this.getController('notes').value;
			})
		)
	}
	getOrderReturn(id: number) {
		this.subscription.add(
			this.orderReturnService.getOrderReturn(id).subscribe((res: any) => {
				this.returnData = res.result
			})
		)
	}
	keypressValidation(event: any, itemName: String | null = null) {
		console.log(itemName, 'item name')

		return !itemName
			? event.charCode == 8 || event.charCode == 0 || event.charCode == 13
				? null
				: event.charCode >= 48 && event.charCode <= 57
			: null
	}
	acceptOrderReturn() {
		this.dialog
			.open(ConfirmationMessageComponent, {
				width: '485px',
				data: {
					notflex: true,
					image: 'assets/images/empty-wallet-change.svg',
					message: 'CONFIRMATION_MESSAGE.ARE_YOU_SURE_TO_COMPLETE_ORDER_RETURN',
					cancelBtn: 'ACTIONS.NO',
					confirmBtn: 'ACTIONS.YES',
					title: 'ACTIONS.PROCEED_ORDER_RETURN',
					confirmBtnStyle: `bg-gradient text-white`,
					cancelBtnStyle: ` border-[1px] border-secondry-color-Gray text-dark-grey border-solid`,
				},
			})
			.afterClosed()
			.subscribe({
				next: (res) => {
					if (res) {
						delete this.formData.controls['payStatus']

						let body = {
							RefundId: this.returnData.orderReturn.id,
							notes : this.notes,
							extraFees:this.extraFees
							
						}

						this.subscription.add(
							this.orderReturnService.acceptOrderReturnRequest(body).subscribe((res) => {
								this.toaster.success(
									this.translate.instant('TOASTER.ORDER_RETURN_SUCCESS')
								)
								this.router.navigate(['/layout/order-return/'])
							})
						)
					}
				},
			})
	}
	rejectOrderReturn() {
		this.dialog
			.open(ConfirmationMessageComponent, {
				width: '485px',
				data: {
					notflex: true,
					image: 'assets/images/wallet-remove.svg',
					message: 'CONFIRMATION_MESSAGE.ARE_YOU_SURE_TO_REJECT_ORDER_RETURN',
					cancelBtn: 'ACTIONS.NO',
					confirmBtn: 'ACTIONS.YES',
					title: 'ACTIONS.REJECT_ORDER_RETURN',
					confirmBtnStyle: `text-off-white bg-red-error`,
					cancelBtnStyle: ` border-[1px] border-secondry-color-Gray text-dark-grey border-solid`,
				},
				autoFocus: false,
			})
			.afterClosed()
			.subscribe({
				next: (res) => {
					if (res) {
						debugger;
						let body = {
							RefundId: this.returnData.orderReturn.id,
							notes : this.notes,
							extraFees  :this.extraFees
						}

						this.subscription.add(
							this.orderReturnService.rejectOrderReturnRequest(body).subscribe((res) => {
								this.toaster.success(
									this.translate.instant('TOASTER.REFUND_REJECT')
								)
								this.router.navigate(['/layout/order-return/'])
							})
						)
					}
				},
			})
	}

	getController(controlName: string) {
		return this.formData.controls[controlName]
	}
	ngOnDestroy(): void {
		this.subscription.unsubscribe()
	}

	inputChange(event: any) {
	if(event.target.name =='notesInput')
	{
		const input = event.target as HTMLInputElement
		this.notes= input.value
	}
	if(event.target.name =='extraFeesInput')
	{
		const input = event.target as HTMLInputElement
		this.extraFees= input.valueAsNumber
	}	
		
	}
}
